import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:data.dimensions.organization',
    'resource:data.dimensions.organization.entities.affiliate',
    'resource:data.dimensions.organization.entities.affiliate.attributes.serviceRegion',
    'resource:data.dimensions.organization.entities.affiliate.attributes.yearsInOperation',
    'resource:data.dimensions.assessments',
    'resource:data.dimensions.assessments.entities.assessment',
    'resource:data.dimensions.assessments.entities.assessment.attributes.affiliate',
    'resource:data.dimensions.assessments.entities.assessment.attributes.boardEngagement',
    'resource:data.dimensions.assessments.entities.assessment.attributes.boardSize',
    'resource:data.dimensions.assessments.entities.assessment.attributes.caseForSupport',
    'resource:data.dimensions.assessments.entities.assessment.attributes.currentRevenue',
    'resource:data.dimensions.assessments.entities.assessment.attributes.dataAnalyticsAndUsage',
    'resource:data.dimensions.assessments.entities.assessment.attributes.digitalPresence',
    'resource:data.dimensions.assessments.entities.assessment.attributes.donorDatabaseManagement',
    'resource:data.dimensions.assessments.entities.assessment.attributes.donorLifetimeValue',
    'resource:data.dimensions.assessments.entities.assessment.attributes.eventManagement',
    'resource:data.dimensions.assessments.entities.assessment.attributes.girlsServed',
    'resource:data.dimensions.assessments.entities.assessment.attributes.givingFrequency',
    'resource:data.dimensions.assessments.entities.assessment.attributes.grantWriting',
    'resource:data.dimensions.assessments.entities.assessment.attributes.lapsedDonors',
    'resource:data.dimensions.assessments.entities.assessment.attributes.majorGiftExperience',
    'resource:data.dimensions.assessments.entities.assessment.attributes.marketingMaterials',
    'resource:data.dimensions.assessments.entities.assessment.attributes.newDonors',
    'resource:data.dimensions.assessments.entities.assessment.attributes.onlineSplit',
    'resource:data.dimensions.assessments.entities.assessment.attributes.retainedDonors',
    'resource:data.dimensions.assessments.entities.assessment.attributes.staffCount',
    'resource:data.dimensions.assessments.entities.assessment.attributes.stewardshipPrograms',
    'resource:data.dimensions.assessments.entities.assessment.attributes.totalActiveDonors',
    'resource:data.dimensions.fsFunctions',
    'resource:data.dimensions.fsFunctions.entities.function',
    'resource:data.dimensions.fsFunctions.entities.function.attributes.fsFunctionType',
    'resource:data.dimensions.fsRecords',
    'resource:data.dimensions.fsRecords.entities.fsRecord',
    'resource:data.dimensions.fsRecords.entities.fsRecord.attributes.affiliate',
    'resource:data.dimensions.fsRecords.entities.fsRecord.attributes.amount',
    'resource:data.dimensions.fsRecords.entities.fsRecord.attributes.fsFunction',
    'resource:solutions.apps.girlsInc',
    'resource:solutions.apps.girlsInc.pages.summary',
    'resource:solutions.apps.girlsInc.pages.details',
    'resource:solutions.mosaic.pages.girlsInc.summary',
    'resource:solutions.mosaic.pages.girlsInc.details',
    'resource:solutions.mosaic.widgets.girlsInc.affiliatesTable',
    'resource:solutions.mosaic.widgets.girlsInc.baselineDataCollectionFrameworkReportCard',
    'resource:solutions.mosaic.widgets.girlsInc.capacityAssessmentRubricReportCard',
  ],
  description: 'TODO',
  name: 'Girls Inc',
} as const satisfies core.quiver.Package
